import { get, post } from '@/utils/request'
import type { CaptureStatus } from '@/types'

/** 服务状态 */
export interface MockServiceStatus {
  running: boolean
  address: string
}

export interface WorkerServiceStatus {
  running: boolean
  pid: number | null
  last_beat: number | null
  queue_len: number
}

export interface SchedulerServiceStatus {
  /** true=正在触发（未暂停） */
  running: boolean
  /** true=已暂停（任务保留，cron 暂不触发） */
  paused: boolean
  /** 已注册的定时任务数 */
  job_count: number
}

export interface ServicesStatus {
  mock: MockServiceStatus
  worker: WorkerServiceStatus
  scheduler: SchedulerServiceStatus
  /** 抓包代理状态（由 /capture/status 聚合而来，抓包页与服务管理页共用） */
  capture: CaptureStatus
}

/** 查询服务状态（进入页面一次性调用） */
export const getServicesStatus = () => get<ServicesStatus>('/services/status')

/** 启动服务：mock=Mock服务 / worker=Playwright引擎（调度器不适用，走暂停/恢复） */
export const startService = (name: 'mock' | 'worker' | 'scheduler') =>
  post<{ started: boolean; pid?: number | null }>(`/services/${name}/start`)

/** 停止服务 */
export const stopService = (name: 'mock' | 'worker' | 'scheduler') =>
  post<{ stopped: boolean; count?: number }>(`/services/${name}/stop`)

/** 暂停定时调度器（任务保留，cron 暂不触发，错过的触发不补跑） */
export const pauseScheduler = () =>
  post<{ paused: boolean }>('/services/scheduler/pause')

/** 恢复定时调度器（重新开始 cron 触发） */
export const resumeScheduler = () =>
  post<{ paused: boolean }>('/services/scheduler/resume')
